import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourceCenterContentComponent } from './resource-center-content.component';
import { I18nModule } from '@spartacus/core';
import { LocalLoaderComponent } from '../../../../../components/loader/local-loader/local-loader.component';

@NgModule({
  declarations: [ResourceCenterContentComponent],
  imports: [CommonModule, I18nModule, LocalLoaderComponent],
  exports: [ResourceCenterContentComponent],
})
export class ResourceCenterContentModule {}
